import { onBeforeUnmount, reactive, ref } from 'vue';
import { asStore } from '@src/application/store/as-store.js';

export function useIntervalComposable(callback: () => void, timeout: number, uniqueId?: string) {
    const knownUniqueIntervals = asStore('knownUniqueIntervals', () => reactive<{ [key: string]: { count: number, idInterval: number } }>({}));

    const idInterval = ref<number|null>(null);
    const createInterval = () => {
        if (uniqueId && knownUniqueIntervals[uniqueId] && knownUniqueIntervals[uniqueId].count > 0) {
            // create unique intervals only once
            return;
        }

        idInterval.value = setInterval(callback, timeout * 1000);
        if (uniqueId && !knownUniqueIntervals[uniqueId]) {
            knownUniqueIntervals[uniqueId] = { count: 0, idInterval: idInterval.value };
        }
        if (uniqueId && knownUniqueIntervals[uniqueId]) {
            knownUniqueIntervals[uniqueId].count++;
        }
    };

    const removeInterval = () => {
        if (idInterval.value === null) {
            return;
        }
        if (uniqueId && knownUniqueIntervals[uniqueId]) {
            knownUniqueIntervals[uniqueId].count--;
        }
        if (uniqueId && knownUniqueIntervals[uniqueId] && knownUniqueIntervals[uniqueId].count > 0) {
            return;
        }

        clearInterval(idInterval.value);
    };

    onBeforeUnmount(removeInterval);

    return {
        createInterval,
        removeInterval,
    };
}
